import { render, staticRenderFns } from "./securedMedia.vue?vue&type=template&id=b4eab968&scoped=true"
import script from "./securedMedia.vue?vue&type=script&lang=js"
export * from "./securedMedia.vue?vue&type=script&lang=js"
import style0 from "./securedMedia.vue?vue&type=style&index=0&id=b4eab968&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4eab968",
  null
  
)

export default component.exports